"use client";

export { Detail } from "./typography/index.js"
export { LinkPanel } from "./link-panel/index.js"